import { mapDataSource, RawDataSource } from '~/Api/DataSource';
import { ReferencedProduct } from '~/Api/User/ProductGroup/RoMaxPrice/ReferencedProduct';
import Price from '~/utils/Price';

export interface RawReferencedProduct {
	id: string;
	currentExFactoryPrice: Price;
	dataSource: RawDataSource;
}

export const mapReferencedProduct = (product: RawReferencedProduct): ReferencedProduct => {
	return new ReferencedProduct(
		product.id,
		new Price(product.currentExFactoryPrice.value, product.currentExFactoryPrice.currency),
		mapDataSource(product.dataSource)
	);
};
